import { queryClient } from '../../context/constants'
import { axiosInstance } from '../../services/api'
import { authQueryFn, Branches } from '../../services/auth'
import { useSentryQuery } from '../useSentryQuery'

export const useGetClient = () => {
    return useSentryQuery({
        queryKey: ['clientId'],
        queryFn: () => {
            const clientId = queryClient.getQueryData<string>(['clientId'])
            if (!clientId) {
                throw new Error('Client ID not found in query cache')
            }
            return clientId
        },
    })
}

export const useGetBranches = () => {
    const { data: clientId } = useGetClient()
    return useSentryQuery({
        queryKey: ['branches', clientId],
        enabled: Boolean(userDetails?.Company),
        queryFn: () => {
            const branches = queryClient.getQueryData<string>([
                'branches',
                clientId,
            ])
            if (!branches) {
                throw new Error('Branches not found in query cache')
            }
            return branches
        },
    })
}

export const getBranches = ({ company }: { company: string }) => {
    return axiosInstance
        .get('/api/branches', {
            params: { company: company },
        })
        .then((resp) => resp.data as Array<Branches>)
}

export const useAuthHook = () => {
    const { data: clientId } = useGetClient()

    return useSentryQuery({
        queryKey: ['authKeys', clientId],
        queryFn: () => authQueryFn(),
    })
}
